<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="等级名称" name="level_name"></c-form-item>
				</c-form>
			</m-search>
<!--			<m-operate>
			  <c-button color="sys" icon="add" power="b_user_level_edit" @click="levelEdit()">新增等级</c-button>
			</m-operate>-->
			<c-table ref="table" code="user_level_list">

			<c-table-column
				label="等级名称"
				name="level_name"
				width="150"
			></c-table-column>

			<c-table-column
				label="等级徽章"
				name="level_icon"
				width="140"
			>
				<template v-slot="{data}">
					<c-image :src="data.level_icon" width="78" height="24" :background="false"></c-image>
				</template>
			</c-table-column>

			<c-table-column
				label="等级卡片背景图"
				width="250"
				v-if="systemConfig.share_enable == 'ON'"
			>
				<template v-slot="{data}">
					<c-image :src="data.level_card_img" width="183" height="80" :background="false"></c-image>
				</template>
			</c-table-column>
					
			<c-table-column
				label="所属级别"
				name="level_sort"
				width="100"
				v-if="systemConfig.share_enable == 'ON'"
			></c-table-column>
					
			<!-- <c-table-column
				label="享受权益项"
				name="right_count"
				width="120"
				v-if="systemConfig.share_enable == 'ON'"
			></c-table-column>

			<c-table-column
				label="等级折扣"
				name="discount"
				width="120"
                v-if="systemConfig.agency_price_mode == 1"
			>
		        <template v-slot="{data}">
		          {{data.discount}}<span style="font-weight: bold;">&nbsp;%</span>
		        </template>
			</c-table-column>

			<c-table-column
				label="升级方式"
				name="up_type"
				width="120"
				v-if="systemConfig.share_enable == 'ON'"
			>
                <template #default="{data}">
                    <span v-if="data.up_type_name && data.up_type_name.length > 0">
                        <li v-for="(item, i) in data.up_type_name">{{item}}</li>
                    </span>
                    <span v-else>--</span>
                </template>
			</c-table-column> -->

			<c-table-column
				type="button"
				fixed="right"
				width="120"
				label="操作"
			>
				<template v-slot="{data}">
                    <!-- <c-table-button v-if="systemConfig.share_enable == 'ON'" power="b_user_level_view" @click="navigateTo(`/user_level_detail/${data.id}`)">查看</c-table-button> -->
					<c-table-button power="b_user_level_edit" @click="levelEdit(data)">编辑</c-table-button>
<!--					<c-table-button power="b_user_level_edit" v-if="data.id!=0" @click="removeUserLevel(data)">删除</c-table-button>-->
				</template>
			</c-table-column>
			</c-table>

			<c-dialog ref="editUserLevelDialog" :title="editState ? '编辑会员等级' : '新增会员等级'" width="750" @resolve="submitEditUserLevel">
				<c-form ref="edit_form">
					<c-form-item type="hidden" name="id"></c-form-item>
					<c-form-item type="input" label="等级名称" name="level_name" maxlength="30" word="等级名称只允许包含中文、英文字母、数字、下划线，长度不超过30个字符"></c-form-item>
					<c-form-item type="number" decimal="0"  label="等级折扣" :limit="[1,100]" name="discount" required word="%（举例：输入80%表示当前等级用户购买商品时，下单价格是商品报价的80%）"></c-form-item>
					<c-form-item type="image" label="等级徽章" limit="1" name="level_icon" required button file-word="建议尺寸：240×64像素，格式支持：jpg、png<br><a class='s-link' href='https://cdn.yunchange.com/app_static/psd/%E4%BC%9A%E5%91%98%E5%BE%BD%E7%AB%A0.psd'>下载模板</a>"></c-form-item>
					<c-form-item v-model="levelColor" type="color" label="徽章文字颜色" name="icon_text_color" required></c-form-item>
					<c-form-item type="textarea" label="备注" name="remark" maxlength="150"></c-form-item>
				</c-form>
			</c-dialog>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";

	export default {
		name: 'm_user_level',
		computed: {
			...mapState(['systemConfig'])
		},
		data() {
			return {
				editState:false,
				levelColor:'#FFEBC3'
			}
		},

		mounted() {
			this.$refs.search.search();
			this.$bus.$on('user_level_list.update', data => {
			  // 刷新列表
			  this.$refs.table.update();
			});
		},

		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/user_level/list',
					data
				});
			},
			//新增等级
			levelEdit(data) {
				if (this.systemConfig.share_enable == 'ON' && data){//开通分享-编辑
                    this.navigateTo(`/user_level_edit/${data.id}`);
                }else if (this.systemConfig.share_enable == 'ON' && !data){//开通分享-新增
					this.navigateTo('/user_level_add');
				}else if (this.systemConfig.share_enable != 'ON' && data){//未开通分享-编辑
					this.editUserLevel(data);
				}else if (this.systemConfig.share_enable != 'ON' && !data){
					this.editUserLevel();
				}
			},
			/**打开 新增/编辑 弹窗**/
			editUserLevel(data){
				//清空表单数据
				this.$refs.edit_form.clear();
				this.$refs.editUserLevelDialog.open();
				if (data){
					var formData = {};
					formData.id = data.id;
					formData.level_name = data.level_name;
					formData.discount = (data.discount*100).toFixed(0);
					formData.remark = data.remark;
					formData.level_icon = data.level_icon;
					formData.icon_text_color = data.icon_text_color||this.levelColor;
					this.editState = true;//编辑
					this.$refs.edit_form.set(formData);
				}else {
					this.editState = false;//新增
					var formData = {};
					formData.icon_text_color = this.levelColor;
					this.$refs.edit_form.set(formData);
				}
			},
			/**提交修改**/
			submitEditUserLevel(stop){
				stop();
				this.$refs.edit_form.submit({
					url: '/user_level/edit',
					rule: {
						level_name: '请输入等级名称',
						level_icon: '请上传等级徽章',
						discount: '请输入等级折扣'
					},
					success: (data, res) => {
						//关闭弹窗
						this.$refs.editUserLevelDialog.close();
						this.$message({
							text:'操作成功！'
						});
						// 清空表单数据
						this.$refs.edit_form.clear();
						this.$refs.search.search();
					}
				});
			},
			//删除用户等级
			removeUserLevel(data) {
				this.$confirm({
					text: '确定要删除【'+data.level_name+'】吗？',
					resolve: () => {
						this.request({
							url: '/user_level/remove',
							data: {
								id: data.id
							},
							loading: true,
							success: data => {
								this.$message({
									text: '删除成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			}
		}
	}
</script>